import { formatDayMonth, formatNumber, type DayNutrition } from '@jungles/shared';

export function HomeNutrition({ day, date, target, loading, failed, onRetry }: {
  day: DayNutrition | null; date: string; target: number | null;
  loading: boolean; failed: boolean; onRetry: () => void;
}) {
  const cells = [['kcal', '🔥', 'Калории', 'ккал'], ['p', '🥚', 'Белки', 'г'],
    ['f', '🥑', 'Жиры', 'г'], ['c', '🍞', 'Углеводы', 'г']] as const;
  const knownTarget = typeof target === 'number' && Number.isFinite(target) && target > 0 ? target : null;
  const empty = day && day.meals && Object.values(day.meals).length === 4 &&
    Object.values(day.meals).every(meal => Array.isArray(meal.entries) && meal.entries.length === 0) &&
    cells.every(([key]) => day[key] === 0);
  return <section id="my-day" className="hero home-nutrition" aria-label="Питание" aria-busy={loading}>
    <div className="row"><h2>Питание</h2><span className="nt">Сегодня, {formatDayMonth(date)}</span></div>
    <div className="day-inline">{cells.map(([key, emoji, label, unit]) => {
      const raw = day?.[key];
      const value = typeof raw === 'number' && Number.isFinite(raw) && raw >= 0 ? raw : null;
      return <div className="day-cell" key={key}>
        <span className="day-emoji" aria-hidden="true">{emoji}</span><span className="day-label">{label}</span>
        <b aria-label={`${label}: ${value === null ? 'нет данных' : formatNumber(value)} ${unit}`}>
          {value === null ? '—' : formatNumber(value)}<small>{unit}</small>
        </b>
        {key === 'kcal' && knownTarget !== null ? <>
          <small className="day-target">из {formatNumber(knownTarget)}</small>
          {value !== null ? <div className="day-track" role="progressbar" aria-label="Цель калорий"
            aria-valuemin={0} aria-valuemax={knownTarget} aria-valuenow={Math.min(value, knownTarget)}
            aria-valuetext={`${formatNumber(value)} из ${formatNumber(knownTarget)} ккал`}>
            <i style={{ width: `${Math.min(100, value / knownTarget * 100)}%` }} />
          </div> : null}</> : null}
      </div>;
    })}</div>
    {failed ? <button type="button" className="back day-status" onClick={onRetry}>Не удалось загрузить питание · Повторить</button>
      : loading && !day ? <p className="nt day-status">Загружаем питание…</p>
      : empty ? <p className="nt day-status">Сегодня пока нет записей</p>
      : day && cells.some(([key]) => typeof day[key] !== 'number' || !Number.isFinite(day[key])) ? <p className="nt day-status">Часть данных о питании отсутствует</p> : null}
  </section>;
}
